import "./icon-input-field.css";
import { createRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AlertIcon from "../../modules/manage-alerts/components/cells/icon";
import { EditIcon, DeleteIcon } from "../table/assets";
import { Button } from "@mui/material";

interface IIconInputFieldProps {
  iconMemberName: string;
  currentIcon: string;
  defaultIcon: Blob;

  onIconChanged(data: FormData): void;
}

export function IconInputField(props: IIconInputFieldProps) {
  const { onIconChanged, iconMemberName } = props;
  const browseRef = createRef<HTMLInputElement>();
  const { t } = useTranslation("common");

  const [currentIcon, setCurrentIcon] = useState<string>(
    props.currentIcon || ""
  );

  const [defaultIcon, setDefaultIcon] = useState<string>(
    props.currentIcon || ""
  );

  useEffect(() => {
    initializeDefaultIcon();
  }, []);

  let fileReader: FileReader;
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event || !event.target || !event.target.files) return;

    if (event.target.files.length === 0) {
      return;
    }

    const data = new FormData();
    data.append(iconMemberName, event.target.files[0]);

    fileReader = new FileReader();
    fileReader.onloadend = onFileLoaded;
    fileReader.readAsDataURL(event.target.files[0]);

    onIconChanged(data);
  };

  const onFileLoaded = (e: ProgressEvent<FileReader>) => {
    const context = fileReader.result;
    if (!context) return;

    setCurrentIcon(context.toString());
  };

  const onRemove = () => {
    setCurrentIcon(defaultIcon);
    const data = new FormData();

    data.append(iconMemberName, props.defaultIcon);
    onIconChanged(data);
  };

  const browseForFile = () => {
    if (browseRef!.current! === null) return;
    browseRef!.current!.click();
  };

  const hiddenInputComponent = () => {
    return (
      <input
        ref={browseRef}
        className="input-icon-field-input-browse-button"
        accept="image/*"
        type="file"
        name="file"
        value=""
        onChange={onChange}
      />
    );
  };

  const initializeDefaultIcon = () => {


    var reader = new FileReader();
    reader.readAsDataURL(props.defaultIcon);
    reader.onloadend = function () {
      var base64data = reader.result;
      if (currentIcon === "") {
        setCurrentIcon(base64data!.toString());
      }
      setDefaultIcon(base64data!.toString());
    };
  };

  const editIconComponent = () => {
    return (
      <div className="input-icon-field-button-container">
        <div className="input-icon-field-button">
          <Button
            onClick={browseForFile}
            startIcon={<EditIcon className="input-icon-field-action-icon" />}
          >
            {t("changeIcon").toUpperCase()}
          </Button>
          {hiddenInputComponent()}
        </div>
        <div className="input-icon-field-button">
          <Button
            onClick={onRemove}
            disabled={currentIcon === defaultIcon}
            startIcon={
              <DeleteIcon className="input-icon-field-action-icon input-icon-delete" />
            }
          >
            {t("removeIcon").toUpperCase()}
          </Button>
        </div>
      </div>
    );
  };

  const editIconElements = () => {
    return (
      <div className="input-icon-field-edit">
        <div className="input-icon-field-browse-style">
          <span className="input-icon-field-selected-file">
            <AlertIcon data={currentIcon} />
          </span>
        </div>
        {editIconComponent()}
      </div>
    );
  };

  return editIconElements();
}
